import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';

// Create payment order
export const createPaymentOrder = async (planId) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/payment/create-order`, 
      { plan_id: planId },
      { withCredentials: true }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get payment order status
export const getPaymentOrderStatus = async (orderId) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/payment/order-status/${orderId}`, {
      withCredentials: true
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}; 